import {
    CLAPI
} from '../clchart/cl.api.js'

export const CHART_KBAR_FWIN = {
    // 浮动窗口特殊标记
    style: 'fwindow',
    // 头信息定义 通常用于需要特殊显示的数据
    header: {
        display: 'text',
        spaceY: 3,
        spaceX: 1,
        rows: [{
            cols: [{
                align: 'left',
                maxchs: 8,
                field: 'date',
                clr: 'code',
                getvar: 'getIntVar',
            }]
        }],
    },
    // 统一表格信息
    boards: {
        upper: {
            display: 'text', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 3,
            rows: [{
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '昨收',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'agop',
                            clr: 'txt',
                            getvar: 'getFltVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '今开',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'open',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最高',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'maxp',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最低',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'minp',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最新',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'newp',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '涨幅',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'rate',
                            getclr: 'getZeroClr',
                            getvar: 'getPctVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '振幅',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'wave',
                            getclr: 'getFltClr',
                            getvar: 'getPctVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '总量',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'sumv',
                            getclr: 'getVolClr',
                            getvar: 'getVolVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '总额',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'summ',
                            getclr: 'getMnyClr',
                            getvar: 'getMnyVar',
                        },
                    ]
                },
            ],
        },
    }
}

// 周期信息定义
export const CHART_KBAR_HEAD = {
    style : 'horizontal',  // 'vertical'
    maxchs : 8,
    ctrls: [{
            clickValue: 'date',
            label: '日',
        },
        {
            clickValue: 'week',
            label: '周',
        },
        {
            clickValue: 'month',
            label: '月',
        },
    ]
}

export const kbar_main_prcma_lines = [
    {
        className: CLAPI.ClDrawKBar, // 图按ClDrawKBar类来画
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['maxp'], // 参与计算最大值的标签
            minvalue: ['minp'] // 参与计算最小值的标签
        }
        // 第一根线默认的key是跟随chart的hotKey变化而变化的，其他线要么自己有数据，要么根据hotKey加上公式计算出自己的key
    },
    {
            className:CLAPI. ClDrawMark,
            info: {
                drawInfo: 'none',
                color: 'yellow',
                drawMethod: 'strToMap',
                fieldY: 'right',
            },
    },
    {
        className: CLAPI.ClDrawZLine,
        info: { // 输出在信息栏目（title）的数据
            label: ' 5:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYM1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.MA('newp',5)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '10:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYM2', // 获取数据的key，
            command: `out = this.MA('newp',10)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '20:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYM3', // 获取数据的key，
            command: `out = this.MA('newp',20)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '60:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYM4', // 获取数据的key，
            command: `out = this.MA('newp',60)` // 公式只能输出值到out中
        }
    }
]

export const kbar_main_grade_lines = [{
        className: CLAPI.ClDrawKBar, // 图按ClDrawKBar类来画
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['maxp'], // 参与计算最大值的标签
            minvalue: ['minp'] // 参与计算最小值的标签
        },
        // 第一根线默认的key是跟随chart的hotKey变化而变化的，其他线要么自己有数据，要么根据hotKey加上公式计算出自己的key
    },
    {
        className: CLAPI.ClDrawMark,
        info: {
            drawInfo: 'none',
            color: 'button',
            drawMethod: 'strToMap',
            fieldY: 'right',
        },
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '60:',
            fieldY: 'value',
            format: 'price',
            color: 'lwhite',
        },
        formula: {
            key: 'DAYM1', // 获取数据的key，
            command: `out = this.MA('newp',60)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: { // 输出在信息栏目（title）的数据
            label: ' S1:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYMAS1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.MAAREA('newp', 60, 1)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value']  // 参与计算最小值的标签
        // },
        info: {
            label: 'S2:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAS2', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, 2)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value'] // 参与计算最小值的标签
        // },
        info: {
            label: 'S3:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAS3', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, 3)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: { // 输出在信息栏目（title）的数据
            label: ' B1:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYMAB1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.MAAREA('newp', 60, -1)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value'] // 参与计算最小值的标签
        // },
        info: {
            label: 'B2:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAB2', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, -2)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value']  // 参与计算最小值的标签
        // },
        info: {
            label: 'B3:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAB3', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, -3)` // 公式只能输出值到out中
        }
    },
]

const Kbar_axisX = {
        lines: 0, // 纵向线有几根，不包括两边的框线
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    }

const Kbar_axisY_float = {
        lines: 1, // 横向线有几根
        left: { //左边的坐标信息
            display: 'both', // none不显示, both, noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'float' // 输出数据的格式 rate, price 保留一定小数位 vol 没有小数
        },
        right: { //右边的坐标信息
            display: 'both', // none不显示，noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'float' // rate, price vol
        }
    }

const Kbar_axisY_money = {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'money'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'money'
        }
    }
export const CHART_KBAR_MAIN = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    buttons: [
        CLAPI.ChartRes.BUTTON_ZOOMIN,
        CLAPI.ChartRes.BUTTON_ZOOMOUT,
        CLAPI.ChartRes.BUTTON_LOCKED,
        CLAPI.ChartRes.BUTTON_RIGHT,
        { // 均线轨道
            clickName: 'maarea',
            drawMethod: 'text', // 显示文本
            clickInfo: [{
                    label: '均',
                    value: 'prcma'
                },
                {
                    label: '轨',
                    value: 'grade'
                },
            ],
        },
    ],
    scroll: { // 是否显示下方的游标
        display: 'normal' // 'none' does not show normal
    },
    title: { // 标题
        display: 'text', // none does not show btn button text
        label: 'K线' // label information to be displayed
    },
    axisX: {
        display: 'none',
        lines: 0, // 纵向线有几根，不包括两边的框线
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'normal',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 3, // 横向线有几根
        left: { //左边的坐标信息
            display: 'both', // none不显示, both, noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // 输出数据的格式 rate, price 保留一定小数位 vol 没有小数
        },
        right: { //右边的坐标信息
            display: 'both', // none不显示，noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // rate, price vol
        }
    },
    // 下面是当前图形的所有需要画的线，一般非特殊的线，直接通过配置就可以得到想要的效果
    lines: [],
}

export const CHART_KBAR_DDZB = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '大单占比' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_float,
    lines: [{
        className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['sum_bigr5'], // 参与计算最大值的标签
                minvalue: ['sum_bigr5'] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
                filled: true,
                fieldX: 'index',
                fieldY: 'sum_bigr5', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '5:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float'
            },
            formula: {
                key: 'BIGMB1', // 获取数据的key，
                command: `out = this.MA('sum_bigr5',5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '10:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float'
            },
            formula: {
                key: 'BIGMB2', // 获取数据的key，
                command: `out = this.MA('sum_bigr5',10)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '20:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float'
            },
            formula: {
                key: 'BIGMB3', // 获取数据的key，
                command: `out = this.MA('sum_bigr5',20)` // 公式只能输出值到out中
            }
        },
    ]
}

export const CHART_KBAR_ZLJM = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '散户持仓' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_float,
    lines:  [ 
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['dsvrchg'], // 参与计算最大值的标签
                minvalue: ['dsvrchg'] // 参与计算最小值的标签
        },
        info: {
            label: "机构持仓:",
            filled: true,
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'dsvrchg', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['swveer'], // 参与计算最大值的标签
            minvalue: ['swveer'] // 参与计算最小值的标签
        },
        info: {
            label: "机构期望:",
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'swveer', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    ]
}

export const CHART_KBAR_MMQD = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '买卖强度' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_float,
    lines:  [ 
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: "B:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        },
        formula: {
            key: 'BIGM1', // 获取数据的key，
            command: `out = this.MA('mapbr', 3)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: "S:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        },
        formula: {
            key: 'BIGM2', // 获取数据的key，
            command: `out = this.MA('mapsr', 3)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: "强度:",
            filled: true,
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        },
        formula: {
            key: 'BIGM3', // 获取数据的key，
            command: `out = this.MA('mapcr', 3)` // 公式只能输出值到out中
        }
    },
    ]
}

export const CHART_KBAR_APDD = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '暗盘' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_money,
    lines: [{
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['mbigm'], // 参与计算最大值的标签
            minvalue: ['mbigm'] // 参与计算最小值的标签
        },
        info: {
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'mbigm', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money',
        }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '10:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money'
            },
            formula: {
                key: 'BIGM1', // 获取数据的key，
                command: `out = this.SUMMA('mbigm',10, 5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '20:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money'
            },
            formula: {
                key: 'BIGM2', // 获取数据的key，
                command: `out = this.SUMMA('mbigm',20, 5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '30:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money'
            },
            formula: {
                key: 'BIGM3', // 获取数据的key，
                command: `out = this.SUMMA('mbigm',30, 5)` // 公式只能输出值到out中
            }
        },
    ]
}
export const CHART_KBAR_SHCC = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '散户持仓' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_float,
    lines:  [ 
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['xvolr'], // 参与计算最大值的标签
                minvalue: ['xvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "X:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'xvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['yvolr'], // 参与计算最大值的标签
                minvalue: ['yvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "Y:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'yvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['zvolr'], // 参与计算最大值的标签
                minvalue: ['zvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "Z:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'zvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['dvolr'], // 参与计算最大值的标签
                minvalue: ['dvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "机构持仓:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'dvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    // {
    //     className: CLAPI.ClDrawVBar,
    //     extremum: { // 如何取极值
    //         method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //         maxvalue: ['xvolr'], // 参与计算最大值的标签
    //         minvalue: ['xvolr'] // 参与计算最小值的标签
    //     },
    //     info: {
    //         filled: true,
    //         label: "机构持仓:",
    //         showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
    //         fieldX: 'date',
    //         fieldY: 'xvolr', // 需要显示的变量，从key中获取对应的数据标签
    //         format: 'float',
    //     }
    // },
    {
        className: CLAPI.ClDrawMark,
        info: {
            drawInfo : 'none',
            clrMethod  : 'getBSClr',
            drawMethod : 'strToMap',
            // place : {
            //     style : 'field', // top foot field
            //     field : 'newp',
            // },
            fieldY: 'bsflag',
        },
    },
    ]
}

export const CHART_KBAR_CCCB = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '持仓成本' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_float,
    lines:  [ 
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['xsump'], // 参与计算最大值的标签
                minvalue: ['xsump'] // 参与计算最小值的标签
        },
        info: {
            label: "XP:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'xsump', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['ysump'], // 参与计算最大值的标签
                minvalue: ['ysump'] // 参与计算最小值的标签
        },
        info: {
            label: "YP:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'ysump', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['zsump'], // 参与计算最大值的标签
                minvalue: ['zsump'] // 参与计算最小值的标签
        },
        info: {
            label: "ZP:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'zsump', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    ]
}

export const CHART_KBAR_CCSY = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '持仓成本' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_money,
    lines:  [ 
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['xreap'], // 参与计算最大值的标签
                minvalue: ['xreap'] // 参与计算最小值的标签
        },
        info: {
            label: "XR:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'xreap', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['yreap'], // 参与计算最大值的标签
                minvalue: ['yreap'] // 参与计算最小值的标签
        },
        info: {
            label: "YR:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'yreap', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['zreap'], // 参与计算最大值的标签
                minvalue: ['zreap'] // 参与计算最小值的标签
        },
        info: {
            label: "ZR:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'zreap', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    ]
}
export const CHART_KBAR_CCYC = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '预测' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_float,
    lines:  [  
    // {
    //     className: CLAPI.ClDrawZLine,
    //     extremum: { // 如何取极值
    //             method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //             maxvalue: ['swveer'], // 参与计算最大值的标签
    //             minvalue: ['swveer'] // 参与计算最小值的标签
    //     },
    //     info: {
    //         label: "W:",
    //         showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
    //         fieldX: 'date',
    //         fieldY: 'swveer', // 需要显示的变量，从key中获取对应的数据标签
    //         format: 'float',
    //     }
    // },
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['swveer'], // 参与计算最大值的标签
            minvalue: ['swveer'] // 参与计算最小值的标签
        },
        info: {
            label: "W:",
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'date',
            fieldY: 'swveer', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['smveer'], // 参与计算最大值的标签
                minvalue: ['smveer'] // 参与计算最小值的标签
        },
        info: {
            label: "M:",
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'smveer', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    ]
}

export const CHART_KBAR_DDHJ = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '大单合计' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_money,
    lines: [{
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['cur_bigm'], // 参与计算最大值的标签
            minvalue: ['cur_bigm'] // 参与计算最小值的标签
        },
        info: {
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'cur_bigm', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money',
        }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '10:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money'
            },
            formula: {
                key: 'BIGM1', // 获取数据的key，
                command: `out = this.SUMMA('cur_bigm',10, 5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '20:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money'
            },
            formula: {
                key: 'BIGM2', // 获取数据的key，
                command: `out = this.SUMMA('cur_bigm',20, 5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '30:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money'
            },
            formula: {
                key: 'BIGM3', // 获取数据的key，
                command: `out = this.SUMMA('cur_bigm',30, 5)` // 公式只能输出值到out中
            }
        },
    ]
}

export const CHART_KBAR_DXQL = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '信号' // 需要显示的文字信息
    },
    axisX: Kbar_axisX,
    axisY: Kbar_axisY_float,
    lines: [{
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: [5], // 参与计算最大值的标签
                minvalue: [0] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
                filled: true,
                fieldX: 'index',
                fieldY: 'nums', // 需要显示的变量，从key中获取对应的数据标签
                format: 'vol',
            }
        }
    ]
}

export const analyinfos = [
    {
        analyname : 'DDHJ',
        label: '大单合计',
        lines : CHART_KBAR_DDHJ,
    },
    {
        analyname : 'DDZB',
        label: '大单占比',
        lines : CHART_KBAR_DDZB,
    },
    {
        analyname : 'ZLJM',
        label: '主力揭秘',
        lines : CHART_KBAR_ZLJM,
    },
    {
        analyname : 'SHCC',
        label: '散户持仓',
        lines : CHART_KBAR_SHCC,
    },
    {
        analyname : 'CCCB',
        label: '持仓成本',
        lines : CHART_KBAR_CCCB,
    },
    {
        analyname : 'CCSY',
        label: '兑现收益',
        lines : CHART_KBAR_CCSY,
    },
    {
        analyname : 'CCYC',
        label: '持仓预测',
        lines : CHART_KBAR_CCYC,
    },
    {
        analyname : 'DXQL',
        label: '短线潜龙',
        lines : CHART_KBAR_DXQL,
    },
    {
        analyname : 'MMQD',
        label: '买卖强度',
        lines : CHART_KBAR_MMQD,
    },
    {
        analyname : 'APDD',
        label: '暗盘大单',
        lines : CHART_KBAR_APDD,
    },
]

export const CHART_ANALY_HEAD = {
    style : 'horizontal',  // 'vertical'
    maxchs : 8,
    ctrls: [{
            clickValue: 'DDHJ',
            label: analyinfos[0].label,
        },
        {
            clickValue: 'DDZB',
            label: analyinfos[1].label,
        },
        {
            clickValue: 'ZLJM',
            label: analyinfos[2].label,
        },
        {
            clickValue: 'SHCC',
            label: analyinfos[3].label,
        },
        {
            clickValue: 'CCCB',
            label: analyinfos[4].label,
        },
        {
            clickValue: 'CCSY',
            label: analyinfos[5].label,
        },
        {
            clickValue: 'CCYC',
            label: analyinfos[6].label,
        },
        {
            clickValue: 'DXQL',
            label: analyinfos[7].label,
        },
        {
            clickValue: 'MMQD',
            label: analyinfos[8].label,
        },
        {
            clickValue: 'APDD',
            label: analyinfos[9].label,
        },
    ]
}